import { Button } from 'antd'
import { CancelAndSaveContainer } from 'components/AddCancelSaveButtons'
import { TextInputStyled } from 'components/form/inputs/InputStyles'
import React, { useState } from 'react'
import styled from 'styled-components'

const FormContainer = styled.div<{ $marginBottom?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  ${({ $marginBottom }) => $marginBottom && 'margin-bottom: 16px;'}
  padding: 12px;
  background: ${({ theme }) => theme.forecast.background2};
  border-radius: 6px;
`

interface CreatePlanFormProps {
  onCreatePlan: (planName: string) => Promise<void>
  onCancel: () => void
  isLoading?: boolean
  placeholder?: string
  marginBottom?: boolean
}

export const CreatePlanForm: React.FC<CreatePlanFormProps> = ({
  onCreatePlan,
  onCancel,
  isLoading = false,
  placeholder = 'Enter new plan name',
  marginBottom = false,
}) => {
  const [planName, setPlanName] = useState('')

  const handleCreate = async () => {
    if (!planName.trim()) return

    try {
      await onCreatePlan(planName.trim())
      setPlanName('')
    } catch (error) {
      console.error('Failed to create plan:', error)
    }
  }

  const handleCancel = () => {
    setPlanName('')
    onCancel()
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleCreate()
    }
  }

  return (
    <FormContainer $marginBottom={marginBottom}>
      <TextInputStyled
        placeholder={placeholder}
        value={planName}
        onChange={(e) => setPlanName(e.target.value)}
        onKeyDown={handleKeyPress}
        autoFocus
      />
      <CancelAndSaveContainer>
        <Button size='small' onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          type='primary'
          size='small'
          onClick={handleCreate}
          disabled={!planName.trim() || isLoading}>
          Create Plan
        </Button>
      </CancelAndSaveContainer>
    </FormContainer>
  )
}
